import { getEnumFromValueType } from '@semios/app-platform-values-helpers-and-types'
import { threeItemLabel } from 'App/data-export/valueTypeRenderers/renderers/_utils/labelHelpers'
import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { translate } from 'i18n/i18n'
import { mapApiEmitterTypeToLabel } from 'utils/mapApiEmitterTypeToLabel'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const irrigationPressure:
  | typeof valueTypeRenderers.irrigationPressureSemios_emitterBuriedDrip1
  | typeof valueTypeRenderers.irrigationPressureSemios_emitterBuriedDrip2
  | typeof valueTypeRenderers.irrigationPressureSemios_emitterDrip1
  | typeof valueTypeRenderers.irrigationPressureSemios_valve1
  | typeof valueTypeRenderers.irrigationPressureSemios_valve2
  | typeof valueTypeRenderers.irrigationPressureSemios_valve3
  | typeof valueTypeRenderers.irrigationPressureSemios_valve4
  | typeof valueTypeRenderers.irrigationPressureSemios_valve5
  | typeof valueTypeRenderers.irrigationPressureSemios_valve6
  | typeof valueTypeRenderers.irrigationPressureSemios_valve7
  | typeof valueTypeRenderers.irrigationPressureSemios_valve8
  | typeof valueTypeRenderers.irrigationPressureSemios_valve9
  | typeof valueTypeRenderers.irrigationPressureSemios_valve10
  | typeof valueTypeRenderers.irrigationPressureSemios_emitterDrip2
  | typeof valueTypeRenderers.irrigationPressureSemios_emitterFloodFurrow
  | typeof valueTypeRenderers.irrigationPressureSemios_emitterMicrospray
  | typeof valueTypeRenderers.irrigationPressureSemios_emitterOther
  | typeof valueTypeRenderers.irrigationPressureSemios_emitterOverheadCoolingMicrospray
  | typeof valueTypeRenderers.irrigationPressureSemios_emitterOverheadCoolingSprinkler
  | typeof valueTypeRenderers.irrigationPressureSemios_emitterSprinkler
  | typeof valueTypeRenderers.irrigationPressureSemios_postFilter
  | typeof valueTypeRenderers.irrigationPressureSemios_preFilter
  | typeof valueTypeRenderers.irrigationPressureSemios_pump
  | typeof valueTypeRenderers.irrigationPressureSemios_systemPressure = {
  label: (valueType: string) => {
    const emitterType = getEnumFromValueType(valueType)
    const emitterLabel = emitterType ? mapApiEmitterTypeToLabel(emitterType) : valueType

    return translate.phrases.templates('{{labelA}} ({{labelB}})', {
      labelA: translate.phrases.banyanApp('Irrigation Pressure'),
      labelB: emitterLabel,
    })
  },
  point: ({ metadata, valueType }) => {
    const emitterType = getEnumFromValueType(valueType)
    const emitterLabel = emitterType ? mapApiEmitterTypeToLabel(emitterType) : valueType
    const unitLabel = unitConverter.irrigationPressure().suffix()

    const baseLabel = threeItemLabel([
      translate.phrases.banyanApp('Irrigation Pressure'),
      emitterLabel,
      unitLabel,
    ])

    if (metadata.aggregationInterval === 'UNAGGREGATED') {
      return (value) => [
        {
          id: 'value',
          value: unitConverter.irrigationPressure(value === null ? null : value.average).valueAsString(),
          label: baseLabel,
        },
      ]
    } else {
      return makeNumberRenderer({
        baseLabel,
        render: (n) => unitConverter.irrigationPressure(n).valueAsString(),
      })
    }
  },
}
